/* global window */
import * as React from 'react';
import { connect } from 'react-redux';

// components
import OverlayLoader from '../../../parts/OverlayLoader';
import CardCTA from '../../../parts/CardCTA';
import FailureOverlay from '../../../parts/FailureOverlay';

// services
import { registerInPersonPayment } from '../../../services/payment/PaymentService';

class InPersonPaymentPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loadState: 'none',
      paymentType: props.paymentType,
      verified: false
    };
    this.registerPayment = this.registerPayment.bind(this);
    this.timeout = null;
  }

  componentWillReceiveProps(newProps) {
    if (this.state.paymentType !== newProps.paymentType) {
      this.setState({
        verified: false,
        paymentType: newProps.paymentType
      });
    }
  }

  registerPayment() {
    const { orderIdx, amountToPay, onComplete, onError } = this.props;

    this.setState({ loadState: 'loading' });
    return registerInPersonPayment(orderIdx, this.state.paymentType, amountToPay)
      .then((res) => {
        if (!res.data) return Promise.reject();
        return onComplete()
          .then(() => this.setState({ loadState: 'none', verified: false }));
      })
      .catch((e) => {
        onError('Failed to register payment');
        this.setState({ loadState: 'failed', verified: false });
        window.setTimeout(() => this.setState({ loadState: 'none' }), 4000);
      });
  }

  render() {
    const { amountToPay, sofologist, loadingAmount } = this.props;
    const { loadState, paymentType, verified } = this.state;

    const amount = (amountToPay && amountToPay !== null)
      ? Number(amountToPay).toFixed(2)
      : '0.00';

    return (
      <div className="u-position-relative u-padding-y u-flex u-flex-column u-flex-center-both">
        <OverlayLoader
          active={loadState === 'loading' || loadingAmount}
          background="white"
        />
        {
          loadState === 'failed'
          && <FailureOverlay background="white" />
        }
        <p className="u-text-center u-w-80">
          Confirm {paymentType.toUpperCase()} payment of £{amount} from {sofologist.location} as {sofologist.login}
        </p>
        {/* verify */
          !verified && (
            <CardCTA
              onBtnClick={() => this.setState(prev => ({ verified: !prev.verified }))}
              disabled={loadState === 'loading'}
              text={`Verify Amount £${amount}`}
              extraClass={'u-w-80 u-padding-y-tiny'}
            />)
        }
        {/* action */
          verified && (
            <CardCTA
              onBtnClick={this.registerPayment}
              disabled={!verified || loadState === 'loading'}
              text={`Confirm Payment: £${amount}`}
              extraClass={'u-w-80 u-padding-y-tiny'}
            />)
        }
      </div >
    );
  }
}

const mapStateToProps = state => ({
  sofologist: state.sofologist
});

export default connect(mapStateToProps, null)(InPersonPaymentPanel);



// WEBPACK FOOTER //
// ./src/cards/templates/payBalanceSections/InPersonPaymentPanel.js